export function isLocal() {
    return !!(
        typeof window !== 'undefined' &&
        window.location &&
        window.location.host &&
        window.location.host.match(
            /((localhost|0.0.0.0):(11000|8000|12000))|github.homeawaycorp.com|wvrgroup.internal|hahosting.local|sea.corp.expecn.com|corp.expecn.com/
        )
    );
}
